const CARGO_TRACK_URLS = {
  "yurtiçi": "https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code={tn}",
  "yurtici": "https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code={tn}",
  "mng": "https://kargotakip.mngkargo.com.tr/?takipNo={tn}",
  "aras": "https://kargotakip.araskargo.com.tr/mainpage.aspx?code={tn}",
  "sürat": "https://www.suratkargo.com.tr/KargoTakip/?kargotakipno={tn}",
  "surat": "https://www.suratkargo.com.tr/KargoTakip/?kargotakipno={tn}",
  "ptt": "https://gonderitakip.ptt.gov.tr/track/verify?q={tn}",
  "hepsijet": "https://www.hepsijet.com/gonderi-takibi/{tn}",
  "sendeo": "https://www.sendeo.com.tr/gonderi-takip?code={tn}",
  "kolay gelsin": "https://www.kolaygelsin.com/gonderi-takip/{tn}",
  "ups": "https://www.ups.com/track?tracknum={tn}",
  "dhl": "https://www.dhl.com/tr-tr/home/tracking/tracking-express.html?submit=1&tracking-id={tn}",
  "trendyol express": "https://www.trendyolexpress.com/gonderi-takip/{tn}",
};

export function cargoTrackUrl(company, trackingNumber) {
  if (!company || !trackingNumber) return "";
  const key = company.toLocaleLowerCase("tr");
  for (const [k, url] of Object.entries(CARGO_TRACK_URLS)) {
    if (key.includes(k)) return url.replace("{tn}", encodeURIComponent(trackingNumber));
  }
  return "";
}
